<div class="clearfix title-holder col-sm-12">
  <div class="title">
    Message Feed
    <span class="unread-badge badge badge-danger" *ngIf="unreadMessageCount">{{ unreadMessageCount }}</span>
    <app-page-help videoId="OstgX6CvDpw" class="ml-2"></app-page-help>
    <app-default-inbox-indicator [inboxName]="inboxName"></app-default-inbox-indicator>
  </div>
</div>
<div class="main-content col-sm-12">
  <div class="clearfix container-box">
    <div class="col-sm-12 input-holder-top filters-box">
      <div class="row no-margin">
        <div class="col-sm-9">
          <div class="row">
            <div class="col-auto">
              <app-select-search
                *ngIf="(rentals$ | async)?.length"
                matTooltip="Only show messsages that related to the selected rentals."
                matTooltipPosition="above"
                matTooltipClass="text-center"
                bindValue="id"
                bindLabel="name"
                floatLabel="never"
                [items]="rentals$ | async"
                [ctrl]="filters.get('rentals')"
                placeholder="Rentals"
                class="w-auto mr-2"
              ></app-select-search>
            </div>
            <div class="col-auto">
              <mat-form-field [floatLabel]="'never'" class="mat-block">
                <mat-select
                  matTooltip="Only show messages with the selected booking status."
                  matTooltipPosition="above"
                  matTooltipClass="text-center"
                  [formControl]="filters.get('status')"
                  placeholder="Status"
                >
                  <mat-option value="all">All Status</mat-option>
                  <mat-option [value]="BookingStatus.Inquiry">Inquiry</mat-option>
                  <mat-option [value]="BookingStatus.Arriving">Arriving</mat-option>
                  <mat-option [value]="BookingStatus.InHouse">In House</mat-option>
                  <mat-option [value]="BookingStatus.Departed">Departed</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-auto">
              <mat-form-field [floatLabel]="'never'" class="mat-block">
                <mat-select
                  matTooltip="Only show messages with the selected type."
                  matTooltipPosition="above"
                  matTooltipClass="text-center"
                  [formControl]="filters.get('readStatus')"
                  placeholder="Type"
                >
                  <mat-option value="all">All</mat-option>
                  <mat-option [value]="MessageReadStatus.Read">Read</mat-option>
                  <mat-option [value]="MessageReadStatus.Unread">Unread</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-right">
          <mat-form-field [floatLabel]="'never'" class="search mat-block">
            <input
              matInput
              [matTooltip]="inputTooltip"
              matTooltipPosition="above"
              matTooltipClass="text-center"
              [formControl]="filters.get('search')"
              placeholder="Search here..."
              type="text"
            />
            <i class="far fa-search"></i>
            <i
              *ngIf="filters.get('search').value.length > 0"
              (click)="$event.stopPropagation(); onClearSearch()"
              class="clear-search far fa-times"
            ></i>
          </mat-form-field>

          <div class="btn-clear-filters" matTooltip="Clear all filters" (click)="clearFilters()">
            <i class="fal fa-minus-circle"></i>
          </div>
        </div>
      </div>
    </div>
    <div [hidden]="!isLoaded">
      <div class="table-responsive">
        <div class="feed-items">
          <div class="pinned-items">
            <ng-container *ngFor="let message of pinnedMessages">
              <ng-container *ngTemplateOutlet="messageTpl; context: { $implicit: message }"></ng-container>
            </ng-container>
          </div>
          <div *ngIf="messages.length && pinnedMessages.length" class="divider"></div>
          <ng-container *ngFor="let message of data">
            <ng-container *ngTemplateOutlet="messageTpl; context: { $implicit: message }"></ng-container>
          </ng-container>
        </div>
        <mat-paginator
          #paginator
          [length]="messages.length"
          [class.hidden]="!messages.length"
          [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
          [showFirstLastButtons]="true"
          (page)="onSetPage($event)"
        >
        </mat-paginator>
      </div>
      <app-empty-table *ngIf="!messages.length && !pinnedMessages.length" [type]="tableType"></app-empty-table>
    </div>
    <app-loading-section *ngIf="!isLoaded"></app-loading-section>
  </div>
</div>

<ng-template #messageTpl let-message="$implicit">
  <div class="feed-item" (click)="onClick(message)" [ngClass]="message.read ? 'read' : 'unread'">
    <div class="avatar-holder">
      <span class="avatar">{{ getGuestName(message) | capitalize | initials }}</span>
    </div>
    <div class="content">
      <div class="top">
        <div class="title">
          <span *ngIf="!message.guestId">{{ getGuestName(message) }}</span>
          <a *ngIf="message.guestId" (click)="onGuestClick(message); $event.stopPropagation()">{{
            getGuestName(message)
          }}</a>
          <ng-container *ngIf="message.rentalId">
            <span class="from">for</span>
            <a (click)="onRentalClick(message); $event.stopPropagation()">{{ message.rentalName }}</a>
          </ng-container>
        </div>
        <div class="received">{{ message.receivedOn | epoch }}</div>
        <div class="actions" (click)="$event.stopPropagation()" *ngIf="!(1 | isReadonlyRole)">
          <a
            [matTooltip]="message.pinned ? 'Unpin message' : 'Pin message'"
            matTooltipPosition="above"
            matTooltipClass="text-center"
            [ngClass]="{ pinned: message.pinned }"
            (click)="onTogglePinned(message)"
          >
            <i class="fa-map-pin" [ngClass]="{ fas: message.pinned, fal: !message.pinned }"></i>
          </a>
          <a
            matTooltip="Remove message from feed"
            matTooltipPosition="above"
            matTooltipClass="text-center"
            (click)="onRemoveFromFeed(message)"
          >
            <i class="fab fa-stack-overflow"></i>
          </a>
          <a
            matTooltip="Delete message"
            matTooltipPosition="above"
            matTooltipClass="text-center"
            (click)="onRemove(message)"
          >
            <i class="fal fa-trash-alt"></i>
          </a>
        </div>
      </div>
      <div class="text">{{ message.messageTxt }}</div>
    </div>
  </div>
</ng-template>
